import { render, staticRenderFns } from "./InappropriateAssignmentNotificationConfirmation.vue?vue&type=template&id=28f7118c&scoped=true&"
import script from "./InappropriateAssignmentNotificationConfirmation.vue?vue&type=script&lang=js&"
export * from "./InappropriateAssignmentNotificationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7118c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VDialog,VSpacer})
